import { Node_Type } from './../../../ricos-schema/legacy/wix/rich_content/v1';
import { INSERT_PLUGIN_BUTTONS } from './../../../editor-common';

const map = {
  [INSERT_PLUGIN_BUTTONS.IMAGE]: Node_Type.IMAGE,
  [INSERT_PLUGIN_BUTTONS.GALLERY]: Node_Type.GALLERY,
  [INSERT_PLUGIN_BUTTONS.POLLS]: Node_Type.POLL,
  [INSERT_PLUGIN_BUTTONS.DIVIDER]: Node_Type.DIVIDER,
  [INSERT_PLUGIN_BUTTONS.HTML]: `${Node_Type.HTML}.html`,
  [INSERT_PLUGIN_BUTTONS.VIDEO]: `${Node_Type.VIDEO}.video`,
  [INSERT_PLUGIN_BUTTONS.INSTAGRAM]: `${Node_Type.LINK_PREVIEW}.instagram`,
  [INSERT_PLUGIN_BUTTONS.YOUTUBE]: `${Node_Type.VIDEO}.youTube`,
  [INSERT_PLUGIN_BUTTONS.TIKTOK]: `${Node_Type.LINK_PREVIEW}.tiktok`,
  [INSERT_PLUGIN_BUTTONS.TWITTER]: `${Node_Type.LINK_PREVIEW}.twitter`,
  [INSERT_PLUGIN_BUTTONS.PINTEREST]: `${Node_Type.LINK_PREVIEW}.pinterest`,
  [INSERT_PLUGIN_BUTTONS.FACEBOOK]: `${Node_Type.LINK_PREVIEW}.facebook`,
  [INSERT_PLUGIN_BUTTONS.STORES]: `${Node_Type.APP_EMBED}.product`,
  [INSERT_PLUGIN_BUTTONS.EVENTS]: `${Node_Type.APP_EMBED}.event`,
  [INSERT_PLUGIN_BUTTONS.BOOKINGS]: `${Node_Type.APP_EMBED}.booking`,
  [INSERT_PLUGIN_BUTTONS.BUTTON]: Node_Type.BUTTON,
  [INSERT_PLUGIN_BUTTONS.CODE_BLOCK]: Node_Type.CODE_BLOCK,
  [INSERT_PLUGIN_BUTTONS.SOUND_CLOUD]: `${Node_Type.AUDIO}.soundCloud`,
  [INSERT_PLUGIN_BUTTONS.GIF]: Node_Type.GIF,
  [INSERT_PLUGIN_BUTTONS.FILE]: Node_Type.FILE,
  [INSERT_PLUGIN_BUTTONS.EMOJI]: 'wix-draft-plugin-emoji',
  [INSERT_PLUGIN_BUTTONS.UNDO]: 'UNDO',
  [INSERT_PLUGIN_BUTTONS.REDO]: 'REDO',
  [INSERT_PLUGIN_BUTTONS.TABLE]: Node_Type.TABLE,
  [INSERT_PLUGIN_BUTTONS.COLLAPSIBLE_LIST]: Node_Type.COLLAPSIBLE_LIST,
  [INSERT_PLUGIN_BUTTONS.ADSENSE]: `${Node_Type.HTML}.adsense`,
  [INSERT_PLUGIN_BUTTONS.AUDIO]: `${Node_Type.AUDIO}.audio`,
  [INSERT_PLUGIN_BUTTONS.SPOTIFY]: `${Node_Type.AUDIO}.spotify`,
  [INSERT_PLUGIN_BUTTONS.LAYOUT]: Node_Type.LAYOUT,
};

export const getToolbarIdByInsertPlugin = (
  pluginId: (typeof INSERT_PLUGIN_BUTTONS)[keyof typeof INSERT_PLUGIN_BUTTONS]
) => map[pluginId];
